import { render } from "./SendingProfilesPage.vue?vue&type=template&id=928f5df6&lang=html"
import script from "./SendingProfilesPage.vue?vue&type=script&lang=js"
export * from "./SendingProfilesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__